module.exports = __webpack_public_path__ + "static/img/GH.a1a73277.jpg";